import React, { ChangeEvent } from 'react';
import { Box, Typography, OutlinedInput } from '@mui/material';
import styles from '../styles';

interface Props {
  id: number;
  content: number | undefined;
  preview: boolean;
  onChange: (id: number, value: number) => void;
}

export function Spacer({ id, content, preview, onChange }: Props) {
  const height = typeof content === 'number' ? content : 0;

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const value = Number(e.target.value || 0);
    onChange(id, value);
  }

  if (preview) {
    return (
      <Box sx={{ height }} />
    );
  }

  return (
    <Box sx={(theme) => styles.widget(theme, { preview })}>
      <Typography variant="h6" sx={{ mb: 8 }}>Spacer</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Typography variant="caption" sx={{ minWidth: 80 }}>Height (px)</Typography>
        <OutlinedInput type="number" value={height} onChange={handleChange} />
      </Box>
      <Box sx={{ mt: 12, border: '1px dashed #d0d0d0', backgroundColor: '#fafafa', height }} />
    </Box>
  );
}


